var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "80%",
        visible: _vm.visible,
        "before-close": _vm.cancel,
        "close-on-click-modal": false,
        title: _vm.$t("SeaExport.DataComparison")
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "harbour-data-compare" },
        [
          _c("div", { staticClass: "harbour-compare-tit" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("Message.Explain")))]),
            _c("span", [_vm._v(_vm._s(_vm.$t("Message.compareHarbourTips1")))]),
            _c(
              "span",
              { staticStyle: { display: "block", "margin-left": "37px" } },
              [_vm._v(_vm._s(_vm.$t("Message.compareHarbourTips2")))]
            ),
            _c(
              "span",
              { staticStyle: { display: "block", "margin-left": "37px" } },
              [_vm._v(_vm._s(_vm.$t("Message.compareHarbourTips3")))]
            ),
            _c("span", { staticStyle: { "margin-left": "37px" } }, [
              _vm._v("4.")
            ]),
            _c("span", { staticStyle: { color: "orange" } }, [
              _vm._v(_vm._s(_vm.$t("Message.compareHarbourTips4")))
            ])
          ]),
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { "min-height": "100%" },
              attrs: {
                "left-style": { flex: "none", "max-width": "190px" },
                "right-style": { overflow: "hidden" }
              }
            },
            [
              _c(
                "template",
                { slot: "left" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      "min-width": "160px",
                      width: "100%",
                      height: "100%"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.harbour.gridOptions,
                      "row-data": _vm.harbour.rowData,
                      "column-defs": _vm.harbour.columnDefs
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.harbour.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "template",
                { slot: "right" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      "min-width": "160px",
                      width: "100%",
                      height: "100%"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.detail.gridOptions,
                      "row-data": _vm.detail.rowData,
                      "column-defs": _vm.detail.columnDefs
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.detail.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "1" },
              on: { click: _vm.submitHarbour }
            },
            [_vm._v(_vm._s(_vm.$t("Message.UpdatedData")))]
          ),
          _c("el-button", { attrs: { no: "2" }, on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel2")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }